import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AdminProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && user.email) {
        try {
          // Check if this email exists in the admins collection
          const normalizedEmail = user.email.trim().toLowerCase();
          const adminDocRef = doc(db, 'admins', normalizedEmail);
          const adminDoc = await getDoc(adminDocRef);
          
          if (adminDoc.exists()) {
            setAuthenticated(true);
            sessionStorage.setItem('adminAuthenticated', 'true');
          } else {
            setAuthenticated(false);
            sessionStorage.removeItem('adminAuthenticated');
            console.warn('User is authenticated but not an admin:', user.email);
          }
        } catch (error) {
          console.error('Error verifying admin status:', error);
          setAuthenticated(false);
        }
      } else {
        setAuthenticated(false);
        sessionStorage.removeItem('adminAuthenticated');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        background: '#0a0e1e',
        color: '#fff',
        fontFamily: 'inherit'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loading-spinner">جاري التحقق من صلاحيات الإدارة...</div>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
